<template>
  <div>
    <div class="d-flex justify-content-between mb-2">
      <div class="section-title align-items-center d-flex">
        {{ $t("scheduleList") }}
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <b-dropdown name="listview" id="listview" variant="outline-blue">
          <template v-slot:button-content>
            <!-- {{ $t("viewing") }}&nbsp;
            <strong>{{ selectedvalue }}</strong>
            &nbsp;Of&nbsp; -->
            <strong>{{ viewingRange }}</strong>
          </template>
          <b-dropdown-item
            v-for="(list, listIndex) in viewingnumbers"
            :key="listIndex"
            @click="onDropDownChangeValue(list.name)"
            >{{ list.name }}</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2"></div>
      </div>
    </div>

    <div class="col-12">
      <div class="row white-wrapper" style="margin-bottom: 0px">
        <div class="col-lg-6 col-xl-4 mb-1">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.cinema && selected.cinema.length > 0 ? 'shift-up' : ''
              "
              >{{ $tc("cinema", 1) }}</label
            >
            <multiselect
              :disabled="isRoleID"
              :options="CinemasList"
              v-model="selectedCinema"
              :searchable="true"
              label="cine_name"
              track-by="cine_id"
              placeholder=""
              @input="
                onSelectCinema($event);
                isCinemaSelected = true;
              "
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
          </div>
          <p class="error_message">
            <span
              v-if="submitted && selectedCinema && selectedCinema.length == 0"
              >{{ msgcinema }}</span
            >
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-1">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.screen_name && selected.screen_name.length > 0
                  ? 'shift-up'
                  : ''
              "
              >{{ $tc("screen", 1) }}</label
            >
            <multiselect
              :options="ScreenList"
              v-model="selectedScreen"
              :searchable="true"
              label="screen_name"
              track-by="screen_id"
              placeholder=""
              @input="
                onSelectScreen($event);
                isScreenSelected = true;
              "
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
          </div>
          <p class="error_message">
            <span
              v-if="submitted && selectedScreen && selectedScreen.length == 0"
              class="error_message"
              >{{ msgscreen }}</span
            >
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-1">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.movie_name && selected.movie_name.length > 0
                  ? 'shift-up'
                  : ''
              "
              >{{ $tc("movie", 1) }}</label
            >
            <multiselect
              :options="MoviesList"
              v-model="selectedMovie"
              :searchable="true"
              label="movie_name"
              track-by="md_id"
              placeholder=""
              @input="
                onSelectMovie($event);
                isMovieSelected = true;
              "
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
          </div>
          <p class="error_message">
            <span
              v-if="submitted && selectedMovie && selectedMovie.length == 0"
              class="error_message"
              >{{ msgmovie }}</span
            >
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-1">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="showdate"
                  v-on:click="clearSelectedDate()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="showdate"
                  name="showdate"
                  id="showdate"
                  v-validate="'required'"
                  :typeable="true"
                  @input="isDateSelected = true"
                ></Datepicker>
                <!-- {{showdate.length}} -->
                <label :class="typeof showdate === 'object' ? 'active' : ''">{{
                  $t("date")
                }}</label>
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('showdate')">{{
                  errors.first("showdate")
                }}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-1">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.status_name && selected.status_name.length > 0
                  ? 'shift-up'
                  : ''
              "
              >{{ $tc("type", 1) }}</label
            >
            <multiselect
              :options="status_list"
              v-model="selectedType"
              :searchable="true"
              label="s_status_display"
              track-by="s_id"
              placeholder=""
              @input="
                onSelectStatus($event);
                isTypeSelected = true;
              "
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
          </div>
        </div>

        <div class="col-lg-4 col-xl-2 align-self-center mb-1">
          <button
            :disabled="btenable"
            @click.prevent="Onfetch()"
            class="btn btn-blue w-100 px-2"
          >
            {{ $t("fetch") }}
          </button>
        </div>

        <div class="col-lg-4 col-xl-2 align-self-center mb-1">
          <button
            @click.prevent.stop="OnClear()"
            class="btn btn-blue w-100 px-2"
          >
            {{ $t("clear") }}
          </button>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center my-3">
        <div class="d-flex"></div>
        <div class="d-flex align-items-center">
          <div class="mx-2 d-flex align-items-center">
            <div>
              <a href="#" @click="ExportExcel()" title="Download as Excel">
                <img
                  src="@/assets/img/icons/excel.svg"
                  height="25"
                  width="25"
                />
              </a>
              <a
                href="#"
                title="Download as PDF"
                @click.prevent="
                  printPdf = true;
                  Onfetch();
                "
              >
                <img
                  src="@/assets/img/icons/pdf-icon.svg"
                  height="25"
                  width="25"
                />
              </a>
            </div>
            <div>
              <div
                class="icon-delete-red blue-icon mx-2 btn"
                v-if="!allowDelete"
                @click="allowDelete = !allowDelete"
                :title="'Delete'"
              ></div>

              <button
                class="btn btn-sm btn-blue"
                v-if="allowDelete"
                :disabled="selected_schedule_length == 0"
                @click="$bvModal.show('delete_confirmation')"
              >
                ({{ selected_schedule_length }}) Confirm Delete
              </button>
              <button
                class="btn btn-sm btn-outline-blue"
                v-if="allowDelete"
                @click="
                  allowDelete = false;
                  selected_schedule = [];
                "
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <!---Excel Export Start-->

      <table
        class="white-wrapper list-view-table d-none"
        v-if="ScheduleListExcel.length > 0"
        ref="exportable_table"
      >
        <thead>
          <tr class="text-center">
            <td style="width: 160px">{{ $tc("cinema", 1) }}</td>
            <td>{{ $t("Date") }}</td>
            <td style="width: 110px">{{ $t("show") }}</td>
            <td style="width: 100px">{{ $tc("screen", 1) }}</td>
            <td style="width: 365px">
              <img
                v-if="this.columnName != 'movie_title'"
                @click="onSortValue('movie_title', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('movie_title', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('movie_title', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("Movie", 1) }}
            </td>
            <td>{{ $tc("Comment") }}</td>
            <!--th class="d-flex justify-content-end">Actions</th-->
          </tr>
        </thead>
        <tbody>
          <tr
            class="text-center light_grey_back"
            v-for="(item, key) in ScheduleListExcel"
            :key="key"
            style="height: 40px"
          >
            <td class="pad_red">
              <div class="d-flex justify-content-start">
                {{ item.cine_name }}
              </div>
            </td>
            <td class="pad_red">{{ item.ss_start_date | dateparse }}</td>
            <td
              class="pad_red"
              style="text-align: right; padding-right: 30px !important"
            >
              {{ item.start_time_show | format24hours }}
            </td>
            <td class="pad_red" style="padding-left: 20px; text-align: left">
              {{ item.screen_name }}
            </td>
            <td class="pad_red" style="text-align: left; padding-left: 35px">
              {{ item.movie || item.movie_title }}
            </td>
            <td class="pad_red text-left">
              {{ item.ss_comment ? item.ss_comment : "-" }}
            </td>
          </tr>
        </tbody>
      </table>

      <!---Excel Export End-->

      <table
        class="white-wrapper list-view-table"
        v-if="ScheduleList.length > 0"
      >
        <thead>
          <tr class="text-center">
            <th style="width: 40px"></th>
            <th class="text-center">{{ $tc("cinema", 1) }}</th>
            <th style="width: 100px">
              <img
                v-if="this.columnName != 'ss_start_date'"
                @click="onSortValue('ss_start_date', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('ss_start_date', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('ss_start_date', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("date") }}
            </th>
            <th style="width: 110px">{{ $t("show") }}</th>
            <th style="width: 100px">{{ $tc("screen", 1) }}</th>
            <th style="width: 320px">
              <img
                v-if="this.columnName != 'movie_title'"
                @click="onSortValue('movie_title', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('movie_title', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('movie_title', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("movie", 1) }}
            </th>
            <th>Comment</th>
            <!--th class="d-flex justify-content-end">Actions</th-->
          </tr>
        </thead>
        <tbody>
          <tr
            class="text-center light_grey_back"
            v-for="(item, key) in ScheduleList"
            :key="key"
            style="height: 40px"
          >
            <td class="pad_red">
              <div class="d-flex justify-content-start">
                <div class="d-flex justify-content-end" v-if="allowDelete">
                  <b-form-checkbox
                    class="j-checkbox"
                    :disabled="item.booked_seats > 0 || item.unpaid_count > 0"
                    v-b-tooltip.hover
                    :title="
                      item.booked_seats > 0
                        ? `(${item.booked_seats}) transaction(s) found, Please Apply for Refund.`
                        : item.unpaid_count > 0
                        ? `(${item.unpaid_count}) Unpaid transaction(s) found, Please Cancel Unpaid Booking.`
                        : ``
                    "
                    :value="item"
                    v-model="selected_schedule"
                  />
                </div>

                <div
                  class="d-flex align-items-center justify-content-end"
                  v-else
                >
                  <b-dropdown right variant="edit" class="ml-0">
                    <b-dropdown-item
                      v-if="$can('update', 'Schedule')"
                      @click.prevent.stop="OpenModal(item, 'Comment')"
                    >
                      {{ $t("add") }}/{{ $t("edit") }} Comment
                    </b-dropdown-item>

                    <b-dropdown-item
                      v-if="
                        new Date(item.ss_start_date) >=
                          new Date(+new Date() - 86400000) &&
                        $can('update', 'Schedule')
                      "
                      @click.prevent.stop="OpenModal(item, 'Schedule')"
                    >
                      {{ $t("edit") }} {{ $t("Schedule") }}
                    </b-dropdown-item>

                    <b-dropdown-item
                      v-if="
                        new Date(item.ss_start_date) >=
                          new Date(+new Date() - 86400000) &&
                        $can('update', 'Schedule')
                      "
                      @click.prevent.stop="OpenModal(item, 'Price')"
                    >
                      {{ $t("update") }} {{ $tc("price", 1) }}
                    </b-dropdown-item>

                    <b-dropdown-item
                      @click="
                        () => {
                          $router.push({
                            name: 'Transactions',
                            query: {
                              cinema_id: item.cine_id,
                              date: moment(item.ss_start_date).format(
                                'YYYY-MM-DD'
                              ),
                              md_id: item.md_id,
                              ss_id: item.ss_id,
                            },
                          });
                        }
                      "
                    >
                      {{ $t("view") }} {{ $t("transactions") }}
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="
                        () => {
                          $router.push({
                            name: 'Unpaid Bookings',
                            query: {
                              cinema_id: item.cine_id,
                              date: moment(item.ss_start_date).format(
                                'YYYY-MM-DD'
                              ),
                              md_id: item.md_id,
                              ss_id: item.ss_id,
                            },
                          });
                        }
                      "
                    >
                      {{ $t("view") }} {{ $t("unpaid") }} {{ $t("booking") }}
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="
                        new Date(item.ss_start_date) >=
                        new Date(+new Date() - 86400000)
                      "
                      :to="{
                        name: 'Schedule Seat Layout',
                        params: {
                          ss_id: item.ss_id,
                          md_id: item.md_id,
                          screen_id: item.screen_id,
                        },
                      }"
                    >
                      Schedule Seat Layout
                    </b-dropdown-item>
                  </b-dropdown>
                </div>

                <!-- {{ item.cine_name }} -->
              </div>
            </td>
            <td>{{ item.cine_name }}</td>
            <td class="pad_red">{{ item.ss_start_date | dateparse }}</td>
            <td
              class="pad_red"
              style="text-align: right; padding-right: 30px !important"
            >
              {{ item.start_time_show | format24hours }}
            </td>
            <td class="pad_red" style="padding-left: 20px; text-align: left">
              {{ item.screen_name }}
            </td>
            <td class="pad_red" style="text-align: left; padding-left: 35px">
              {{ item.movie || item.movie_title }}
            </td>
            <td class="pad_red text-left">
              {{ item.ss_comment ? item.ss_comment : "-" }}
            </td>
          </tr>
        </tbody>
        <tbody v-if="ScheduleList.length === 0">
          <tr></tr>
          <tr>
            <td class="text-center" colspan="6">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>

      <table
        class="white-wrapper list-view-table"
        v-if="ScheduleList.length == 0"
      >
        <thead>
          <tr class="text-center">
            <th style="width: 160px">{{ $tc("cinema", 1) }}</th>
            <th style="width: 100px">
              <img
                v-if="this.columnName != 'ss_start_date'"
                @click="onSortValue('ss_start_date', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('ss_start_date', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('ss_start_date', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("date") }}
            </th>
            <th style="width: 110px">{{ $t("show") }}</th>
            <th style="width: 100px">{{ $tc("screen", 1) }}</th>
            <th style="width: 365px">
              <img
                v-if="this.columnName != 'movie_title'"
                @click="onSortValue('movie_title', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('movie_title', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('movie_title', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("movie", 1) }}
            </th>
            <th>Comment</th>
            <!--th class="d-flex justify-content-end">Actions</th-->
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="6">
              <!-- <p class="h6 text-center">{{ $tc("NoRecords") }}</p> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-modal
      id="delete_confirmation"
      title="Delete Multiple Schedules?"
      hide-footer
      @hide="handleCloseModal"
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-4">
          Are you sure you want to Delete ({{ selected_schedule_length }})
          Schedules?
        </p>

        <div class="col-12 py-2 mb-4">
          <div class="row mx-auto">
            <div class="col-12">
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  v-model="multi_schedule_delete_reason"
                  v-validate="{ required: 'required' }"
                  name="delete_reason"
                  id="delete_reason"
                />
                <label>Reason For Deletion (Required)</label>
              </div>
            </div>
          </div>
        </div>

        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('delete_confirmation')"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          :disabled="!multi_schedule_delete_reason || disableDeleteBtn"
          class="btn btn-danger btn-danger-lg px-4 fs-14"
          @click.prevent.stop="handleDeleteMultipleSchedule()"
        >
          Delete ({{ selected_schedule_length }})
        </button>
      </div>
    </b-modal>

    <b-modal id="add_comment" title="Add Comments" hide-footer>
      <div>
        <div class="mt-4 mb-4">
          <b-form-input
            v-model="comment_add"
            placeholder="Comment"
          ></b-form-input>
        </div>
        <button
          class="btn btn-blue w-100 px-2"
          @click.prevent.stop="onFinalSubmit()"
        >
          Add/Update Comment
        </button>
      </div>
    </b-modal>

    <b-modal
      id="updateMovie"
      ref="updateMovie"
      title="Update Movie"
      hide-footer
      show
    >
      <div>
        <div class="row mx-0">
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{
                  movieSelected.movie || movieSelected.movie_title
                }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{ movieSelected.lang_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.mf_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Run Time</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.lengthMinutes) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Start Time</div>
              <div class="col-8">
                <div class>
                  <vue-timepicker
                    manual-input
                    v-model="movieSelected.startTime2"
                    id="showtime"
                    name="showtime"
                    format="HH:mm"
                    class="time_picker"
                    placeholder="Show Time"
                    input-width="100%"
                    auto-scroll
                    lazy
                    @change="onChangeShowStartTime($event)"
                    v-validate="'required'"
                  ></vue-timepicker>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">End Time</div>
              <div class="col-8">
                <strong>{{
                  movieSelected.ss_end_show_time | timeFormat
                }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Interval Time</div>
              <div class="col-8">
                <strong
                  >{{ movieSelected.cine_interval_time_in_mins }} Mins</strong
                >
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Cleaning Time</div>
              <div class="col-8">
                <strong
                  >{{ movieSelected.cine_cleaning_time_in_mins }} Mins</strong
                >
              </div>
            </div>
          </div>
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Comment</div>
              <div class="col-8">
                <strong
                  >{{
                    movieSelected.ss_comment ? movieSelected.ss_comment : "-"
                  }}
                </strong>
              </div>
            </div>
          </div>

          <div class="col-12 pt-3 text-center">
            <button v-on:click="onUpdate()" class="btn-blue">Update</button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="saveMovie"
      ref="ratecardmodal"
      title="Update Price"
      hide-footer
      show
    >
      <div>
        <div class="row mx-0">
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{
                  movieSelected.movie || movieSelected.movie_title
                }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{ movieSelected.lang_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.mf_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Showtime:</div>
              <div class="col-8">
                <strong>{{ movieSelected.ss_start_show_time }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Runtime:</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.lengthMinutes) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">End Time:</div>
              <div class="col-8">
                <strong>{{ movieSelected.ss_end_show_time }}</strong>
              </div>
            </div>
          </div>

          <div
            class="col-12 border-bottom py-2"
            v-if="
              selectedMoviesInScreens &&
              selectedMoviesInScreens[selectedScreenIndex] &&
              selectedMoviesInScreens[selectedScreenIndex].movies &&
              selectedMoviesInScreens[selectedScreenIndex].movies[
                selectedMovieIndex
              ] &&
              selectedMoviesInScreens[selectedScreenIndex].movies[
                selectedMovieIndex
              ].mycinema_booking_type_id === 3
            "
          >
            <div class="row">
              <div
                class="col-12 d-flex justify-content-center align-items-center"
              >
                This is a private show.
              </div>
            </div>
          </div>

          <div
            v-if="
              selectedScreenSeatTypes &&
              selectedScreenSeatTypes.length > 0 &&
              selectedMoviesInScreens &&
              selectedMoviesInScreens[selectedScreenIndex] &&
              selectedMoviesInScreens[selectedScreenIndex].movies &&
              selectedMoviesInScreens[selectedScreenIndex].movies[
                selectedMovieIndex
              ] &&
              selectedMoviesInScreens[selectedScreenIndex].movies[
                selectedMovieIndex
              ].mycinema_booking_type_id !== 3
            "
            v-for="(SeatTypes, SeatTypesIndex) in selectedScreenSeatTypes"
            :key="SeatTypesIndex"
            class="col-12 border-bottom py-2"
          >
            <div class="row">
              <div class="col-4">{{ SeatTypes.sst_seat_type }}</div>
              <div
                v-if="
                  selectedMoviesInScreens[selectedScreenIndex].movies[
                    selectedMovieIndex
                  ]
                "
                class="col-8 d-flex align-items-center"
              >
                <b-dropdown
                  class="w-100"
                  variant="dropdown-curve"
                  :text="
                    selectedMoviesInScreens[selectedScreenIndex].movies[
                      selectedMovieIndex
                    ].scheduleShowPrice[SeatTypesIndex].rc_name
                  "
                >
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search rate card"
                    class="form-control form-control-sm"
                    v-model="
                      selectedMoviesInScreens[selectedScreenIndex].movies[
                        selectedMovieIndex
                      ].scheduleShowPrice[SeatTypesIndex].searchRateCard
                    "
                    v-on:keyup="
                      onSearchRateCard(
                        selectedScreenIndex,
                        selectedMovieIndex,
                        SeatTypesIndex
                      )
                    "
                    v-on:keydown="
                      onSearchRateCard(
                        selectedScreenIndex,
                        selectedMovieIndex,
                        SeatTypesIndex
                      )
                    "
                  />
                  <b-dropdown-item
                    v-for="(Ratecard, RatecardIndex) in RatecardsList"
                    :key="RatecardIndex"
                    v-on:click="
                      onChangeRateCard(Ratecard, SeatTypes, SeatTypesIndex)
                    "
                    >{{ Ratecard.rc_g_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>
          </div>
          <div
            class="col-12 pt-3 text-center"
            v-if="
              selectedMoviesInScreens &&
              selectedMoviesInScreens[selectedScreenIndex] &&
              selectedMoviesInScreens[selectedScreenIndex].movies &&
              selectedMoviesInScreens[selectedScreenIndex].movies[
                selectedMovieIndex
              ] &&
              selectedMoviesInScreens[selectedScreenIndex].movies[
                selectedMovieIndex
              ].mycinema_booking_type_id !== 3
            "
          >
            <button v-on:click="onClickupdateRateCard()" class="btn-blue">
              Update
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import scheduleService from "@/services/scheduleService";
import ScheduleCommentService from "@/services/ScheduleCommentsService.js";
import MasterService from "@/services/MasterService";
import moment, { min } from "moment";
import DatePicker from "vue2-datepicker";
import momentT from "moment-timezone";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";
import * as XLSX from "xlsx";

export default {
  components: { DatePicker, VueTimepicker, NoRecords },
  data() {
    return {
      disableDeleteBtn: false,
      selectedCinema: null,
      selectedScreen: null,
      selectedMovie: null,
      selectedType: null,
      comments_list: [],
      selected_comment: null,

      perPage: 10,
      perPageExcel: 100000,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: null,
      enable: false,
      btenable: false,
      openindi: false,
      isRoleID: true,
      submitted: false,
      selected: {
        cinema: "",
        screen_name: "",
        movie_name: "",
        show_time: "",
        status_name: "",
      },
      selectedRateCardObject: {},
      selected_schedule: [],
      allowDelete: false,
      multi_schedule_delete_reason: "",
      deleteSubmit: false,
      showdate: "",
      cineid: "",
      screenid: "",
      movieid: "",
      status_id: null,
      CinemasList: [],
      MoviesList: [],
      ScreenList: [],
      selectedMoviesInScreens: [],
      ScheduleList: [],
      ScheduleListExcel: [],
      update_ss_id: null,
      status_list: [],
      movieSelected: [],
      timeZone: {
        tz_name: "",
        tz_utc_offset: "",
      },
      CinemasSettings: {},
      RatecardsList: [],
      RatecardsListCopy: [],
      ScreenforCinema: [],
      selectedScreenSeatTypes: [],
      dateAscending: true,
      dateUpDown: true,
      Flag: null,

      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",
      commentSubmit: false,
      selectedScreenIndex: null,

      comment_add: "",
      sceduleMovieInfo: {},
      pdfPath: "",
      printPdf: false,
    };
  },
  computed: {
    selected_schedule_length() {
      return this.selected_schedule.length;
    },
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
      this.getAllActiveCinemas(obj);
      // this.Onfetch();
      // this.Onexcel();
    } else {
      this.getAllActiveCinemas(obj);
    }
    this.GetAllActiveScreens();
    this.getAllActiveMovies();
    this.getStatuses();
    this.getviewingnumber();
  },
  mounted() {
    this.getCommentsList();
  },
  methods: {
    moment,
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, { sheet: "ScheduleList" });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(wb, fn || "ScheduleList." + (type || "xlsx"));
    },
    excelDownload() {
      let new_records = this.ScheduleListExcel;
      let dateparse = function (value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY")
            : "-";
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY")
            : "-";
      };
      let fulldatemonparse = function (value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY HH:mm")
            : "-";
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY HH:mm")
            : "-";
      };
      let format24hours = function (value) {
        if (!value) return "-";
        else if (value)
          return value ? moment(value, ["h:mm A"]).format("HH:mm") : "-";
      };

      let data = [
        {
          sheet: "Schedule List",
          columns: [
            {
              value: "cine_name",
              label: "Cinema Name",
            },

            {
              value: (row) => dateparse(row.ss_start_date),
              label: "Start Date",
            },

            {
              value: (row) => format24hours(row.start_time_show),
              label: "Show",
            },
            {
              value: "screen_name",
              label: "Screen",
            },
            {
              value: (row) => row.movie || row.movie_title,
              label: "Movie",
            },
            {
              value: (row) => (row.ss_comment ? row.ss_comment : "-"),
              label: "Comment",
            },
          ],
          content: new_records,
        },
      ];
      let settings = {
        fileName: `ScheduleList${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },
    handleCloseModal() {
      console.log("Called close modal");
      this.multi_schedule_delete_reason = "";
    },
    handleDeleteMultipleSchedule() {
      this.disableDeleteBtn = true;
      console.log("selected_Schedule", this.selected_schedule);
      let payload = {
        selectedSchedules: this.selected_schedule,
        delete_reason: this.multi_schedule_delete_reason,
        cinema_id: this.cineid,
      };
      scheduleService
        .deleteMultipleSchedule(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.disableDeleteBtn = false;
            this.selected_schedule = [];
            this.allowDelete = false;
            this.Onfetch();
            // this.Onexcel();
          } else {
            this.disableDeleteBtn = false;
            console.log("Error:", data.message);
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {
          this.disableDeleteBtn = false;
          this.$bvModal.hide("delete_confirmation");
        });
    },
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.Onfetch();
    },
    convertToHrs: function (value) {
      console.log("🚀 ~ file: ScheduleList.vue ~ line 868 ~ value", value);
      let hours = Math.floor(value / 60);
      let minutes = Math.floor(value % 60);
      return hours + "." + minutes + " Hrs";
    },
    onChangeShowStartTime: function (event) {
      event = new Date(
        moment(event.displayTime, "HH:mm").format("YYYY-MM-DD, HH:mm:ss")
      );
      console.log("🚀 ~ file: ScheduleList.vue ~ line 824 ~ event", event);
      this.movieSelected["selected_time"] = event;
      this.$forceUpdate();
    },
    onChangeRateCard: function (rateCard, seat, SeatTypeIndex) {
      this.selectedRateCardObject.rate_card_id = rateCard.rc_id;
      this.selectedRateCardObject.screen_seat_type_id = seat.sst_id;
      this.selectedRateCardObject.SeatTypeIndex = SeatTypeIndex;
      this.selectedRateCardObject.rate_card_group_id = rateCard.rc_g_id;

      this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        this.selectedMovieIndex
      ].scheduleShowPrice[this.selectedRateCardObject.SeatTypeIndex][
        "rate_card_id"
      ] = this.selectedRateCardObject.rate_card_id;
      this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        this.selectedMovieIndex
      ].scheduleShowPrice[this.selectedRateCardObject.SeatTypeIndex][
        "rc_name"
      ] = rateCard.rc_g_name;
      this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        this.selectedMovieIndex
      ].scheduleShowPrice[this.selectedRateCardObject.SeatTypeIndex][
        "rate_card_group_id"
      ] = rateCard.rc_g_id;
      this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        this.selectedMovieIndex
      ].scheduleShowPrice[this.selectedRateCardObject.SeatTypeIndex][
        "screen_seat_type_id"
      ] = this.selectedRateCardObject.screen_seat_type_id;
    },
    onClickupdateRateCard: function () {
      if (
        (this.selectedRateCardObject &&
          Object.keys(this.selectedRateCardObject).length == 0) ||
        String(this.selectedRateCardObject.SeatTypeIndex).length == 0
      ) {
        this.$toasted.show("Please Select Rate Card");
        return;
      }
      let payload = {
        show_schedule_id:
          this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
            this.selectedMovieIndex
          ].scheduleShowPrice[this.selectedRateCardObject.SeatTypeIndex][
            "schedule_show_id"
          ],
        scheduleshowprice:
          this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
            this.selectedMovieIndex
          ].scheduleShowPrice,
      };

      scheduleService
        .UpdateCinemaScheduleByPrice(payload)
        .then((result) => {
          const { data } = result;
          if (data.status) {
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("err :", err);
          this.$toasted.show(this._CatchError);
        });
      this.searchRateCard = "";
      this.$refs.ratecardmodal.hide();
    },
    onUpdate: function () {
      this.getScheduleChecker()
        .then((result) => {
          console.log(
            "🚀 ~ file: ScheduleList.vue ~ line 901 ~ result",
            result
          );
          if (!result.status) {
            this.$toasted.show(result.message);
          } else if (result.status) {
            let start = 0;
            let old_show_time = this.movieSelected.ss_actual_start_date_time;
            let movie_name_format = `${this.movieSelected.movie_title} ${this.movieSelected.mf_name} (${this.movieSelected.lang_name})`;

            console.log("old_show_time :>> ", old_show_time);
            let ss_actual_start_date_time = null;
            let ss_actual_end_date_time = null;
            let ss_actual_start_date = null;
            let ss_actual_end_date = null;
            let ss_end_date = null;
            let ss_end_date_time = null;

            this.movieSelected.start_time = this.onChangeTimePicker(
              this.movieSelected.selected_time
            );
            let cinema_start = this.getScreenPositionCalc(
              this.CinemasSettings.cine_operation_start_time
            );
            let show_start_time = ""; //ref.getScreenPositionCalc(startTime);
            if (
              moment(
                moment().format("YYYY-MM-DD") +
                  " " +
                  this.CinemasSettings.cine_operation_end_time
              ).isSameOrBefore(
                moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_start_time
                )
              )
            ) {
              console.log("camehere11111 :");
              if (
                moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                ).isAfter(
                  moment(
                    moment().format("YYYY-MM-DD") +
                      " " +
                      this.movieSelected.start_time
                  )
                )
              ) {
                show_start_time =
                  4320 +
                  this.getScreenPositionCalc(this.movieSelected.start_time);
              } else {
                console.log("camehere222222222222 :");

                show_start_time = this.getScreenPositionCalc(
                  this.movieSelected.start_time
                );
              }
            } else {
              console.log("camehere333333333333333333333 :");

              show_start_time = this.getScreenPositionCalc(
                this.movieSelected.start_time
              );
            }

            let start_delay = this.getScreenPositionCalc("00:30");
            start = show_start_time - cinema_start + start_delay;
            this.movieSelected.start = start;
            let end_time = moment(this.movieSelected.selected_time)
              .add(parseInt(this.movieSelected.lengthMinutes), "m")
              .toDate();

            this.movieSelected.end_time = moment(end_time).format("hh:mm A");

            let date = moment(this.movieSelected.ss_start_date).format(
              "YYYY-MM-DD"
            );
            let showtime = format24Hours(date, this.movieSelected.start_time);
            let endShowtime = format24Hours(date, this.movieSelected.end_time);
            let ss_start_date_time = +new Date(
              moment(date).format("YYYY-MM-DD") +
                "T" +
                showtime +
                this.timeZone.tz_utc_offset
            );

            function format24Hours(date, time) {
              let newVal = date + " " + time;
              let finalVal = moment(newVal).format("HH:mm");
              return finalVal;
            }

            function toUnixTimeStamp(Datestring) {
              return new Date(Datestring.toString()).getTime() / 1000;
            }

            if (
              moment(
                moment().format("YYYY-MM-DD") +
                  " " +
                  this.CinemasSettings.cine_operation_start_time
              ).isSameOrAfter(
                moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                )
              )
            ) {
              if (
                moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                ).isAfter(
                  moment(
                    moment().format("YYYY-MM-DD") +
                      " " +
                      this.movieSelected.start_time
                  )
                )
              ) {
                ss_actual_start_date = moment(date)
                  .add(1, "days")
                  .format("YYYY-MM-DD");
                ss_actual_start_date_time = +new Date(
                  moment(date).add(1, "days").format("YYYY-MM-DD") +
                    "T" +
                    showtime +
                    this.timeZone.tz_utc_offset
                );
                ss_actual_end_date = moment(date)
                  .add(1, "days")
                  .format("YYYY-MM-DD");
                ss_actual_end_date_time = +new Date(
                  moment(date).add(1, "days").format("YYYY-MM-DD") +
                    "T" +
                    endShowtime +
                    this.timeZone.tz_utc_offset
                );
                ss_end_date = moment(date).add(1, "days").format("YYYY-MM-DD");

                ss_end_date_time = +new Date(
                  moment(date).add(1, "days").format("YYYY-MM-DD") +
                    "T" +
                    endShowtime +
                    this.timeZone.tz_utc_offset
                );
              } else {
                ss_actual_start_date = moment(date).format("YYYY-MM-DD");
                ss_actual_start_date_time = +new Date(
                  moment(date).format("YYYY-MM-DD") +
                    "T" +
                    showtime +
                    this.timeZone.tz_utc_offset
                );
                ss_actual_end_date =
                  this.movieSelected.start_time.split(" ")[1] == "PM" &&
                  this.movieSelected.end_time.split(" ")[1] == "AM"
                    ? moment(date).add(1, "days").format("YYYY-MM-DD")
                    : moment(date).format("YYYY-MM-DD");

                ss_actual_end_date_time =
                  this.movieSelected.start_time.split(" ")[1] == "PM" &&
                  this.movieSelected.end_time.split(" ")[1] == "AM"
                    ? +new Date(
                        moment(date).add(1, "days").format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      )
                    : +new Date(
                        moment(date).format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      );
                ss_end_date =
                  this.movieSelected.start_time.split(" ")[1] == "PM" &&
                  this.movieSelected.end_time.split(" ")[1] == "AM"
                    ? moment(date).add(1, "days").format("YYYY-MM-DD")
                    : moment(date).format("YYYY-MM-DD");

                ss_end_date_time =
                  this.movieSelected.start_time.split(" ")[1] == "PM" &&
                  this.movieSelected.end_time.split(" ")[1] == "AM"
                    ? +new Date(
                        moment(date).add(1, "days").format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      )
                    : +new Date(
                        moment(date).format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      );
              }
            } else {
              ss_actual_start_date = moment(date).format("YYYY-MM-DD");
              ss_actual_start_date_time = +new Date(
                moment(date).format("YYYY-MM-DD") +
                  "T" +
                  showtime +
                  this.timeZone.tz_utc_offset
              );
              ss_actual_end_date =
                this.movieSelected.start_time.split(" ")[1] == "PM" &&
                this.movieSelected.end_time.split(" ")[1] == "AM"
                  ? moment(date).add(1, "days").format("YYYY-MM-DD")
                  : moment(date).format("YYYY-MM-DD");

              ss_actual_end_date_time =
                this.movieSelected.start_time.split(" ")[1] == "PM" &&
                this.movieSelected.end_time.split(" ")[1] == "AM"
                  ? +new Date(
                      moment(date).add(1, "days").format("YYYY-MM-DD") +
                        "T" +
                        endShowtime +
                        this.timeZone.tz_utc_offset
                    )
                  : +new Date(
                      moment(date).format("YYYY-MM-DD") +
                        "T" +
                        endShowtime +
                        this.timeZone.tz_utc_offset
                    );
              ss_end_date =
                this.movieSelected.start_time.split(" ")[1] == "PM" &&
                this.movieSelected.end_time.split(" ")[1] == "AM"
                  ? moment(date).add(1, "days").format("YYYY-MM-DD")
                  : moment(date).format("YYYY-MM-DD");

              ss_end_date_time =
                this.movieSelected.start_time.split(" ")[1] == "PM" &&
                this.movieSelected.end_time.split(" ")[1] == "AM"
                  ? +new Date(
                      moment(date).add(1, "days").format("YYYY-MM-DD") +
                        "T" +
                        endShowtime +
                        this.timeZone.tz_utc_offset
                    )
                  : +new Date(
                      moment(date).format("YYYY-MM-DD") +
                        "T" +
                        endShowtime +
                        this.timeZone.tz_utc_offset
                    );
            }

            let payload = {
              show_schedule_id: this.movieSelected.ss_id,
              screen_id: this.movieSelected.screen_id,
              ss_start_show_time: showtime, // this.movieSelected.start_time,
              ss_end_show_time: endShowtime, // this.movieSelected.end_time,
              ss_start_date_time: ss_start_date_time,
              ss_end_date_time: ss_end_date_time,
              ss_actual_end_date: ss_actual_end_date,
              ss_actual_end_date_time: ss_actual_end_date_time,
              ss_actual_start_date: ss_actual_start_date,
              ss_actual_start_date_time: ss_actual_start_date_time,
              old_show_time: old_show_time,
              movie_format_name: movie_name_format,
            };

            scheduleService
              .UpdateCinemaScheduleByShow(payload)
              .then((result) => {
                this.Onfetch();
                // this.Onexcel();
              })
              .catch((err) => {
                console.log("err :", err);
              });
          }
          this.$refs.updateMovie.hide();
        })
        .catch((err) => {
          this.$refs.updateMovie.hide();
          this.$toasted.show(err);
        });
    },
    getScheduleChecker: function () {
      let currentDate = "";
      let end_time = "";
      if (
        moment(
          moment().format("YYYY-MM-DD") +
            " " +
            this.CinemasSettings.cine_operation_start_time
        ).isSameOrAfter(
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_end_time
          )
        )
      ) {
        console.log("come1");
        if (
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_end_time
          ).isAfter(
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                moment(this.movieSelected.selected_time).format("HH:mm")
            )
          )
        ) {
          console.log("come2");

          this.currentDate =
            moment(this.movieSelected.ss_start_date)
              .add(1, "days")
              .format("YYYY-MM-DD") +
            " " +
            moment(this.movieSelected.selected_time).format("HH:mm");
          this.currentDate = moment(this.currentDate).valueOf();

          this.end_time = moment(
            moment(this.movieSelected.ss_start_date)
              .add(1, "days")
              .format("YYYY-MM-DD") +
              " " +
              moment(this.movieSelected.selected_time).format("HH:mm")
          )
            .add(parseInt(this.movieSelected.lengthMinutes), "m")
            .toDate();

          this.end_time = moment(this.end_time).valueOf();
        } else {
          console.log("come3");

          this.currentDate =
            moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
            " " +
            moment(this.movieSelected.selected_time).format("HH:mm");

          this.currentDate = moment(this.currentDate).valueOf();

          this.end_time = moment(
            moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
              " " +
              moment(this.movieSelected.selected_time).format("HH:mm")
          )
            .add(parseInt(this.movieSelected.lengthMinutes), "m")
            .toDate();

          this.end_time = moment(this.end_time).valueOf();
        }
      } else {
        console.log("come3");

        this.currentDate =
          moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
          " " +
          moment(this.movieSelected.selected_time).format("HH:mm");

        this.currentDate = moment(this.currentDate).valueOf();
        this.end_time = moment(
          moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
            " " +
            moment(this.movieSelected.selected_time).format("HH:mm")
        )
          .add(parseInt(this.movieSelected.lengthMinutes), "m")
          .toDate();

        this.end_time = moment(this.end_time).valueOf();
      }

      this.convertToTime(
        this.movieSelected.start,
        this.movieSelected.lengthMinutes
      );

      return new Promise((resolve, reject) => {
        this.selectedMoviesInScreens = this.selectedMoviesInScreens.map((x) => {
          x.movies = [];
          return x;
        });

        let payload = {
          cinema_id: this.movieSelected.cine_id,
          start_date: moment(this.movieSelected.ss_start_date).format(
            "YYYY-MM-DD"
          ),
          end_date: moment(this.movieSelected.ss_end_date).format("YYYY-MM-DD"),
          ss_show_status: this.movieSelected.ss_show_status,
          groupbyssid: "Y",
        };
        scheduleService
          .GetCinemaSchedule(payload)
          .then((result) => {
            const { data } = result;
            if (data && data.status && data.Records.length > 0) {
              let newRecords = data.Records;
              let array = [];

              for (let index = 0; index < newRecords.length; index++) {
                const element = newRecords[index];
                if (element.ss_id != this.movieSelected.ss_id) {
                  let old_movie_start_date = moment(
                    element.ss_actual_start_date_time
                  )
                    .tz(this.timeZone.tz_name)

                    .format("YYYY-MM-DD HH:mm:ss");
                  let old_movie_end_date = moment(
                    element.ss_actual_end_date_time
                  )
                    .tz(this.timeZone.tz_name)

                    .format("YYYY-MM-DD HH:mm:ss");
                  let new_movie_end_date = moment(this.end_time).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
                  let new_movie_start_date = moment(this.currentDate).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );

                  let valid = moment(old_movie_end_date).isBetween(
                    new_movie_start_date,
                    new_movie_end_date
                  );
                  let validSame =
                    moment(old_movie_end_date).isSame(new_movie_end_date);
                  let validSame1 =
                    moment(old_movie_start_date).isSame(new_movie_start_date);
                  let valid1 = moment(new_movie_end_date).isBetween(
                    old_movie_start_date,
                    old_movie_end_date
                  );

                  if (
                    element.screen_id == this.movieSelected.screen_id &&
                    valid1
                  ) {
                    resolve({
                      status: false,
                      message:
                        "Movie overlapped, Please select different showtime",
                    });
                    break;
                  } else if (
                    element.screen_id == this.movieSelected.screen_id &&
                    valid
                  ) {
                    resolve({
                      status: false,
                      message:
                        "Movie overlapped, Please select different showtime",
                    });
                    break;
                  } else if (
                    element.screen_id == this.movieSelected.screen_id &&
                    validSame
                  ) {
                    resolve({
                      status: false,
                      message:
                        "Movie overlapped, Please select different showtime",
                    });
                    break;
                  } else if (
                    element.screen_id == this.movieSelected.screen_id &&
                    validSame1
                  ) {
                    resolve({
                      status: false,
                      message:
                        "Movie overlapped, Please select different showtime",
                    });
                    break;
                  } else {
                    array.push(element.ss_start_show_time);
                    console.log("1 :");
                  }
                }

                if (array.length === newRecords.length - 1) {
                  console.log("2 :");

                  resolve({ status: true });
                  break;
                }
              }
            } else {
              resolve({ status: true });
            }
          })
          .catch((err) => {
            resolve({ status: false, message: "overlaps", error: err });
          });
      });
    },
    onSearchRateCard: function (screenIndex, movieIndex, RatecardIndex) {
      if (
        this.selectedMoviesInScreens[screenIndex].movies[movieIndex]
          .scheduleShowPrice[RatecardIndex]["searchRateCard"].length > 0
      ) {
        this.RatecardsList = this.RatecardsListCopy.filter((x) => {
          if (
            x.rc_g_name
              .toLowerCase()
              .includes(
                this.selectedMoviesInScreens[screenIndex].movies[
                  movieIndex
                ].scheduleShowPrice[RatecardIndex][
                  "searchRateCard"
                ].toLowerCase()
              )
          )
            return x;
        });
      } else {
        this.RatecardsList = this.RatecardsListCopy;
      }
    },
    async getSchedule(flag) {
      let self = this;
      let payload = {};
      let loader = "";
      loader = this.$loading.show();
      this.selectedMoviesInScreens = this.selectedMoviesInScreens.map((x) => {
        x.movies = [];
        return x;
      });

      payload = {
        cinema_id: this.movieSelected.cinema_id
          ? this.movieSelected.cinema_id
          : this.cineid,
        start_date: moment(this.movieSelected.ss_start_date).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD"),
        groupbyssid: "Y",
      };

      scheduleService
        .GetCinemaSchedule(payload)
        .then(async (result) => {
          const { data } = result;

          loader.hide();

          if (data.status) {
            if (data.Records.length > 0) {
              let newRecords = data.Records;
              const prom = await Promise.all(
                newRecords.map(async (y) => {
                  const prom1 = await Promise.all(
                    this.selectedMoviesInScreens.map((x) => {
                      if (String(y.screen_id) === String(x.screen_id)) {
                        let lengthMinutes =
                          y.mrrdr_runtime +
                          y.cine_cleaning_time_in_mins +
                          y.cine_setting_ads_time_in_mins +
                          y.cine_interval_time_in_mins;

                        let sign = this.movieSelected.tz_utc_offset.charAt(0);
                        let offset =
                          this.movieSelected.tz_utc_offset.substring(1);
                        let hours = offset.split(":")[0];
                        let minutes = offset.split(":")[1];

                        let timeZoneFlag =
                          momentT.tz.guess() === this.movieSelected.tz_name ||
                          ((momentT.tz.guess() == "Asia/Calcutta" ||
                            momentT.tz.guess() == "Asia/Kolkata") &&
                            (this.movieSelected.tz_name == "Asia/Kolkata" ||
                              this.movieSelected.tz_name == "Asia/Calcutta"));

                        x.movies.push({
                          lengthMinutes: lengthMinutes,
                          length: (lengthMinutes * 30) / 10,

                          start: getLength(y.ss_start_show_time, this),

                          selected_time: !timeZoneFlag
                            ? sign == "+"
                              ? moment(y.ss_start_date_time)
                                  .tz(this.movieSelected.tz_name)
                                  .add("-" + hours, "hours")
                                  .add("-" + minutes, "minutes")
                                  .format()
                              : moment(y.ss_start_date_time)
                                  .tz(this.movieSelected.tz_name)
                                  .add(hours, "hours")
                                  .add(minutes, "minutes")
                                  .format()
                            : moment(y.ss_start_date_time).format(),
                          movie_details_id: y.movie_details_id,
                          lang_name: y.language_name,
                          start_time: moment(y.ss_start_show_time, [
                            "HH:mm",
                          ]).format("h:mm A"),
                          end_time: moment(y.ss_end_show_time, [
                            "HH:mm",
                          ]).format("h:mm A"),
                          mf_name: y.movie_format,
                          movie_title: y.movie_title,
                          md_thumbnail_url: y.md_thumbnail_url,
                          ss_start_show_time: y.ss_start_show_time,
                          ss_end_show_time: y.ss_end_show_time,
                          scheduleShowPrice: y.scheduleShowPrice,
                          ss_start_date: y.ss_start_date,
                          ss_end_date: y.ss_end_date,
                          ss_start_date_time: y.ss_start_date_time,
                          ss_end_date_time: y.ss_end_date_time,
                          ss_is_active: y.ss_is_active,
                          ss_show_status: y.ss_show_status,
                          ss_actual_end_date_time: y.ss_actual_end_date_time,
                          ss_actual_start_date_time:
                            y.ss_actual_start_date_time,
                          mycinema_booking_type_id: y.mycinema_booking_type_id,
                        });
                      }
                      return x;
                    })
                  );
                })
              );

              if (flag != "OnSelect") {
                this.$refs.ratecardmodal.show();
              }
            }
          }
          this.selectedScreenIndex = this.selectedMoviesInScreens.findIndex(
            (x) => {
              return x.screen_id == this.movieSelected.screen_id;
            }
          );

          this.ScreenList.map((x) => {
            if (x.screen_id == this.movieSelected.screen_id) {
              this.selectedScreenSeatTypes = x.screen_seat_types;
            }
          });
          this.selectedMovieIndex = this.selectedMoviesInScreens[
            this.selectedScreenIndex
          ].movies.findIndex((x) => {
            return x.movie_details_id == this.movieSelected.md_id;
          });
        })
        .catch((err) => {
          console.log("err :", err);
        });
      function getLength(startTime, ref) {
        let cinema_start = ref.getScreenPositionCalc(
          ref.CinemasSettings.cine_operation_start_time
        );
        let show_start_time = ""; //ref.getScreenPositionCalc(startTime);
        if (
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              ref.CinemasSettings.cine_operation_end_time
          ).isSameOrBefore(
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                ref.CinemasSettings.cine_operation_start_time
            )
          )
        ) {
          if (
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                ref.CinemasSettings.cine_operation_end_time
            ).isAfter(moment(moment().format("YYYY-MM-DD") + " " + startTime))
          ) {
            show_start_time = 4320 + ref.getScreenPositionCalc(startTime);
          } else {
            show_start_time = ref.getScreenPositionCalc(startTime);
          }
        } else {
          show_start_time = ref.getScreenPositionCalc(startTime);
        }

        let start_delay = ref.getScreenPositionCalc("00:30");
        return show_start_time - cinema_start + start_delay;
      }
    },
    getScreenPositionCalc: function (start_time) {
      let cinema_start_time = this.movieSelected.cine_operation_start_time;
      let cinema_ampm = cinema_start_time.split(" ")[0];
      let cinema_minutes = parseInt(cinema_start_time.split(":")[1]);
      let cinema_hours = parseInt(cinema_start_time.split(":")[0]);

      let start = 0;
      let cinema_start = 0;
      let hours = 0;
      let minutes = 0;
      let totalMinutes = 0;
      let ampm = start_time.split(" ")[0];
      minutes = parseInt(start_time.split(":")[1]);
      hours = parseInt(start_time.split(":")[0]);
      if (ampm == "PM" && hours === 12) {
        hours = hours;
      } else if (ampm == "PM") {
        hours = hours + 12;
      }

      if (ampm == "AM" && hours === 12) {
        totalMinutes = minutes;
        cinema_start = parseInt(totalMinutes * 30) / 10;
        return cinema_start;
      } else {
        totalMinutes = parseInt(hours * 60) + minutes;
        cinema_start = parseInt(totalMinutes * 30) / 10;
        return cinema_start;
      }

      totalMinutes = parseInt(hours * 60) + minutes;
      cinema_start = parseInt(totalMinutes * 30) / 10;
      return cinema_start;
    },
    getStatuses() {
      let payload = {
        is_show: "Y",
      };
      ScheduleCommentService.GetStatuses(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.status_list = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    convertToTime: function (value, value1) {
      let totalMinutes = (this.movieSelected.start * 10) / 30;
      let _totalMinutes = Math.floor(
        totalMinutes + this.movieSelected.lengthMinutes
      );

      let _hours = Math.floor(_totalMinutes / 60);
      let _minutes = _totalMinutes % 60;
      let _ampm = "AM";
      if (_hours > 12) {
        _ampm = "PM";
        _hours = _hours - 12;
      }
      _minutes = _minutes >= 10 ? _minutes : "0" + _minutes;
      this.movieSelected.end_time = _hours + ":" + _minutes + " " + _ampm;

      let hours = Math.floor(totalMinutes / 60);
      let minutes = Math.floor(totalMinutes % 60);
      let ampm = "AM";
      if (hours > 12) {
        ampm = "PM";
        hours = hours - 12;
      }
      minutes = minutes >= 10 ? minutes : "0" + minutes;
      this.movieSelected.start_time = hours + ":" + minutes + " " + ampm;
      return hours + ":" + minutes + " " + ampm;
    },
    onChangeTimePicker: function (date) {
      var hours = moment(date).format("hh");
      var minutes = moment(date).format("mm");
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    getCommentsList() {
      ScheduleCommentService.GetComments()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.comments_list = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onFinalSubmit() {
      console.log("ss_id", this.sceduleMovieInfo);
      this.commentSubmit = true;
      this.sceduleMovieInfo.show_schedule_id = this.update_ss_id;
      this.sceduleMovieInfo.ss_comment = this.comment_add;
      console.log("comment_add", this.sceduleMovieInfo.ss_comment);
      let payload = this.sceduleMovieInfo;

      scheduleService
        .UpdateCinemaScheduleByShow(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          this.hideModal("add_comment");
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.Onfetch();
      } else {
        this.currentPage = event;
        this.Onfetch();
      }
    },
    changestatus: function () {
      this.openindi = true;
    },
    OpenModal: function (data, type) {
      if (type == "Comment") {
        this.sceduleMovieInfo = data;
        this.update_ss_id = data.ss_id;
        // this.getScheduleComment(data);
        this.selected_comment = "";
        this.$bvModal.show("add_comment");
        this.comment_add = data.ss_comment;
      } else if (type == "Schedule") {
        console.log("data open modal", data);

        let self = this;
        let sign = data.tz_utc_offset.charAt(0);
        let offset = data.tz_utc_offset.substring(1);

        this.timeZone.tz_name = data.tz_name;
        this.timeZone.tz_utc_offset = data.tz_utc_offset;

        let timeZoneFlag =
          momentT.tz.guess() === data.tz_name ||
          ((momentT.tz.guess() == "Asia/Calcutta" ||
            momentT.tz.guess() == "Asia/Kolkata") &&
            (data.tz_name == "Asia/Kolkata" ||
              data.tz_name == "Asia/Calcutta"));

        this.movieSelected = data;

        this.CinemasSettings.cine_operation_start_time =
          data.cine_operation_start_time;

        this.CinemasSettings.cine_operation_end_time =
          data.cine_operation_end_time;

        this.movieSelected.length = (data.lengthMinutes * 30) / 10;

        this.movieSelected.selected_time = moment(
          moment(data.ss_actual_start_date).format("YYYY-MM-DD") +
            " " +
            data.ss_start_show_time
        ).format();

        this.movieSelected.startTime2 = moment(
          this.movieSelected.selected_time
        ).format("HH:mm");
        this.$bvModal.show("updateMovie");
      } else if (type == "Price") {
        this.movieSelected = data;

        this.CinemasSettings.cine_operation_start_time =
          data.cine_operation_start_time;

        this.CinemasSettings.cine_operation_end_time =
          data.cine_operation_end_time;

        this.RatecardsList.map((x) => {
          if (x.cinema_id == this.cineid) {
            return x;
          }
        });

        this.getSchedule();
      }
    },
    hideModal: function (modal) {
      if (modal == "add_comment") {
        this.$bvModal.hide("add_comment");
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 4 },
        { name: "40", id: 5 },
        { name: "50", id: 6 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    clearSelectedDate: function () {
      this.showdate = "";
    },

    onSelectMovie: function (event) {
      this.selected.movie_name = event.movie_name;
      this.movieid = event.md_id;
      this.dateenable = false;
    },

    onSelectScreen: function (event) {
      // console.log("screen :", screen, screenindex);
      this.selected.screen_name = event.screen_name;
      this.screenid = event.screen_id;
    },
    onSelectStatus: function (event) {
      // console.log("screen :", screen, screenindex);
      this.selected.status_name = event.s_status_display;
      this.status_id = event.s_id;
    },

    onSelectCinema: function (event) {
      this.selected.cinema = event.cine_name;
      this.cineid = event.cine_id;
      this.Onfetch();
      // this.Onexcel();
      this.getSchedule("OnSelect");
      this.getAllActiveScreens(event.cine_id);
    },

    getAllActiveCinemas: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemasList = data.Records;

            this.CinemasList.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selected.cinema = x.cine_name;
                this.cineid = x.cine_id;
                let cinema = {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id,
                };
                this.selectedCinema = cinema;
                // this.onSelectCinema(cinema);
              }
            });
          } else {
            // Show Error message
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    GetAllActiveScreens: function () {
      this.ScreenList = [];
      this.selectedMoviesInScreens = [];

      scheduleService
        .GetAllActieScreens()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            console.log("this.ScreenList", this.ScreenList);
            this.ScreenList = data.Records.filter(
              (x) => x.screen_seat_types.length > 0
            );
            this.ScreenList.map((x) => {
              this.selectedMoviesInScreens.push({
                ...x,
                movies: [],
              });
            });
          } else {
            // Show Message Here:
            console.log("data.message :", data.message);
          }
        })
        .catch(this._CatchError);
    },

    getAllActiveScreens: function (cinema_id) {
      this.ScreenList = [];
      let payload = {
        cinema_id: cinema_id,
      };

      this.selectedMoviesInScreens = [];

      scheduleService
        .GetScreens(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ScreenList = data.Records.filter(
              (x) => x.screen_seat_types.length > 0
            );
            this.ScreenList.map((x) => {
              this.selectedMoviesInScreens.push({
                ...x,
                movies: [],
              });
            });
          } else {
            // Show Message Here:
            console.log("data.message :", data.message);
          }
        })
        .catch(this._CatchError);
    },

    getAllActiveMovies: function () {
      scheduleService
        .GetMovies()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.MovieListResult.length > 0) {
            this.MoviesList = data.MovieListResult;
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch(this._CatchError);
    },

    /* eslint-disable */
    goToRoute: function (path, item) {
      const { screen_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: screen_id,
        },
      });
    },
    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
    Onexcel: function () {
      this.ScheduleListExcel = [];
      let loader = this.$loading.show();

      let payload = {
        cinema_id: this.cineid,
        date: this.showdate,
        screen_id: this.screenid,
        movie_id: this.movieid,
        status_id: this.status_id,
        limit: this.perPageExcel,
        currentPage: 1,
        searchValue: "",
        columnName: "",
        orderBy: "",
      };

      this.btenable = true;

      ScheduleCommentService.getSchedules(payload)
        .then((response) => {
          this.btenable = false;
          const { data } = response;

          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.ScheduleListExcel = data.Records;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
      console.log("OnExcel", payload);
    },
    Onfetch: function () {
      if (this.isCinemaSelected && this.isDateSelected) {
        this.ScheduleList = [];
        let loader = this.$loading.show();

        let payload = {
          cinema_id: this.cineid,
          date: this.showdate,
          screen_id: this.screenid,
          movie_id: this.movieid,
          status_id: this.status_id,
          limit: this.printPdf ? "" : this.perPage,
          currentPage: this.currentPage,
          columnName: this.columnName,
          orderBy: this.orderBy,
          isPdf: this.printPdf,
        };

        this.btenable = true;

        ScheduleCommentService.getSchedules(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;

            if (data && data.status) {
              if (data.Records && data.Records.length > 0) {
                this.ScheduleList = data.Records;
                this.RatecardsList = data.RateCardGroupByCinema;
                this.RatecardsListCopy = data.RateCardGroupByCinema;
                this.ScreenforCinema = data.ScreensByCinema;

                this.ScreenforCinema.map((x) => {
                  this.selectedMoviesInScreens.push({
                    ...x,
                    movies: [],
                  });
                });
                if (!this.printPdf) {
                  this.Onexcel();
                } else {
                  window.open(data.tempFile);
                }
                if (data.totalRows >= 10) {
                  this.rows = data.totalRows;
                } else {
                  this.rows = data.totalRows;
                  this.selectedvalue = data.totalRows;
                }
              } else {
                this.rows = 0;
                this.$toasted.show(data.message);
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      } else {
        this.$toasted.show("Please select Date.");
      }
    },

    OnClear: function () {
      this.selected_schedule = [];
      this.openindi = false;
      this.selected = {
        cinema: "",
        screen_name: "",
        movie_name: "",
        show_time: "",
        status_name: "",
      };

      this.showdate = "";
      this.cineid = "";
      this.screenid = "";
      this.movieid = "";
      this.status_id = null;
      this.selectedType = null;
      this.selectedMovie = null;
      this.selectedCinema = null;
      this.selectedScreen = null;
    },
  },
};
</script>
<style>
.pad_red {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  padding-right: 2px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ScheduleCommentsComponent/ScheduleList.vue